import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { useAuth } from '../../AuthProvider';
import { hideLoading, showLoading } from '../../actions/loaderAction';
import SubHeader from '../../components/SubHeader';
import roles from '@/constant/roles.config';
import { inquiryReportDetail } from '../../actions/inquiryAction';

const TABS = [
  { key: 'total', label: 'Total' },
  { key: 'open', label: 'Open' },
  { key: 'not_open', label: 'Not Open' },
];

function SupplierInquiryReportDetail(props) {
  const { id: inqID } = useParams();
  const { isEndUser, isDemoUser, isPreKYCUser, user, isViewer } = useAuth();

  const [rows, setRows] = useState([]);
  const [pagination, setPagination] = useState({});
  const [counts, setCounts] = useState({ total: 0, open: 0, not_open: 0 });
  const [page, setPage] = useState(1);
  const [activeTab, setActiveTab] = useState('total'); // default = Total

  const getPrefix = () => {
    if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
    if (user && isDemoUser) return roles.DEMO.prefix;
    if (user && isEndUser) return roles.END_USER.prefix;
    if (user && isViewer) return roles.VIEWER.prefix;
    return roles.SUPER_ADMIN.prefix;
  };

  const fetchInqDetail = async () => {
    try {
      props.showLoading();
      const response = await props.getSupplierReport({
        id: inqID,
        tab: activeTab,
        page,
        per_page: 10,
      });

      if (response?.status) {
        setRows(response.data || []);
        setPagination(response.pagination || {});
        setCounts(response.counts || { total: 0, open: 0, not_open: 0 });
      } else {
        setRows([]);
        setPagination({});
      }
    } catch (err) {
      console.error('fetchInqDetail error:', err);
    } finally {
      props.hideLoading();
    }
  };

  useEffect(() => {
    fetchInqDetail();
    // eslint-disable-next-line
  }, [inqID, activeTab, page]);

  const handleTabChange = (key) => {
    if (key === activeTab) return;
    setActiveTab(key);
    setPage(1); // reset pagination when tab changes
  };

  return (
    <div className="new-design">
      <div className="profile-history-log">
        <SubHeader
          layer1="Supplier Inquiries"
          layer2="Supplier Inquiry Report"
          layer3=""
          pageName="Supplier Inquiry Report"
          subTitle=""
          clickable={{ layer1: '', layer2: '', layer3: '' }}
        />

        <div className="row">
          <div className="col-12">
            {/* Tabs */}
            <div className="rep-tabs">
              {TABS.map((tab) => (
                <button
                  type="button"
                  key={tab.key}
                  className={`rep-tab ${activeTab === tab.key ? 'active' : ''}`}
                  onClick={() => handleTabChange(tab.key)}
                >
                  {tab.label} <span className="cnt">({counts[tab.key] ?? 0})</span>
                </button>
              ))}
            </div>

            {/* Table */}
            <div className="p-0 border bg-white rounded card-shadow mt-3 send-receive-table">
              <div className="table-wrape">
                <table className="simple-table list-table" width="100%">
                  <thead>
                    <tr>
                      <th className="id">Sr. No</th>
                      <th className="name">Company</th>
                      <th className="contact-info">Contact Person</th>
                      <th className="contact-info">Email</th>
                      <th className="contact-info">Phone</th>
                      <th className="category">Country</th>
                      <th className="category">Product</th>
                      <th className="category">Category</th>
                      <th className="contact-info">Trade Mode</th>
                      <th className="contact-info">Trade Mode Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.length > 0 ? (
                      rows.map((item, index) => (
                        <tr key={item.id}>
                          <td>{(pagination.from || 1) + index}</td>
                          <td>{item.company_name || '-'}</td>
                          <td>{item.contact_person || '-'}</td>
                          <td>{item.email || '-'}</td>
                          <td>{item.phone || '-'}</td>
                          <td>{item.country || '-'}</td>
                          <td>{item.product || '-'}</td>
                          <td>{item.category || '-'}</td>
                          <td>{item.trade_mode || '-'}</td>
                          <td>{item.trade_mode_type || '-'}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={10}>
                          <div className="text-center mt-3 mb-3">No data found</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Pagination */}
            {pagination.last_page > 1 && (
              <div className="d-flex justify-content-between align-items-center mt-3">
                <span>
                  Showing {pagination.from} to {pagination.to} of {pagination.total}
                </span>
                <div>
                  <button
                    className="btn btn-sm btn-secondary me-2"
                    disabled={page <= 1}
                    onClick={() => setPage((p) => p - 1)}
                  >
                    Prev
                  </button>
                  <button
                    className="btn btn-sm btn-secondary"
                    disabled={page >= pagination.last_page}
                    onClick={() => setPage((p) => p + 1)}
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
  getSupplierReport: (payload) => dispatch(inquiryReportDetail(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SupplierInquiryReportDetail);